import { darkenHexColor } from 'redesign/utils/darkenHexColor'
import styled from 'styled-components'
import breakPoint from 'theme/breakpoints'

export const Container = styled.div`
    display: flex;
    flex: 1;
    height: 100dvh;
    flex-direction: column;
`

export const Header = styled.div`
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    background-color: #fefefe;
    padding: 1rem;

    ${breakPoint.desktop} {
        height: 4rem;
        padding: 1rem 3.5rem;
        box-shadow: 0px 4px 4px 0px rgba(22, 22, 22, 0.04), 0px 8px 24px 0px rgba(22, 22, 22, 0.08);
        margin-bottom: 3rem;
    }
`

export const LogoNav = styled.img`
    max-width: fit-content;
    max-height: 1rem;
`

export const ContainerContent = styled.div<{ bgColor?: string }>`
    display: flex;
    flex: 1;
    flex-direction: column;
    background: ${({ bgColor }) => bgColor};
    ${breakPoint.desktop} {
        border-radius: 1.5rem 1.5rem 0 0;
        flex-direction: row;
        padding: 0 1rem;
        background: #fefefe;
    }
`

export const CalendarContainer = styled.div`
    display: none;

    ${breakPoint.desktop} {
        display: flex;
        padding: 0 1rem;
        flex: 1;

        img {
            display: flex;
            align-self: flex-end;
        }
    }
`

export const Content = styled.div<{ bgColor?: string }>`
    padding: 2.5rem 1rem;
    display: flex;
    flex-direction: column;

    ${breakPoint.desktop} {
        background: ${({ bgColor }) => bgColor};
        flex-direction: column;
        padding: 0 1rem;
        border-radius: 1.5rem;
        width: 32rem;
        padding: 3rem 2rem;
        flex-direction: column;
        justify-content: flex-start;
        margin-right: 2rem;
        margin-bottom: 2.5rem;
    }
`

export const Title = styled.h1`
    color: #fefefe;
    text-align: center;
    font-size: 1.5rem;
    font-style: normal;
    font-weight: 700;
    line-height: 120%; /* 1.8rem */
    margin-bottom: 0.5rem;

    ${breakPoint.desktop} {
        text-align: left;
        font-size: 2.5rem;
        letter-spacing: -0.0625rem;
        margin-bottom: 1rem;
    }
`

export const Subtitle = styled.h2`
    color: #fefefe;
    text-align: center;
    font-size: 1rem;
    font-style: normal;
    font-weight: 400;
    line-height: 150%;

    ${breakPoint.desktop} {
        text-align: left;
    }
`

export const FormContainer = styled.div`
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    flex: 1;
    align-items: center;
    margin-bottom: 0;

    ${breakPoint.desktop} {
        margin-bottom: 2.5rem;
    }
`

export const Form = styled.div`
    display: flex;
    flex-direction: column;
    border-radius: 1.5rem;
    background-color: #fff;
    padding: 1.5rem 1rem 2rem 1rem;
    width: 100%;
    max-width: 27rem;
    box-shadow: 0px 8px 24px 0px rgba(22, 22, 22, 0.08), 0px 4px 4px 0px rgba(22, 22, 22, 0.04);
    margin-bottom: 2.5rem;

    ${breakPoint.desktop} {
        flex-direction: column;
        flex: 1;
        box-shadow: none;
        padding: 0;
    }
`

export const Footer = styled.div<{ bgColor?: string }>`
    display: flex;
    flex-direction: column;
    width: 100%;
    padding: 1rem;
    background-color: ${({ bgColor }) => bgColor && darkenHexColor(bgColor, 0.15)};
    color: #fefefe;
    text-align: center;
    font-size: 0.75rem;
    font-style: normal;
    font-weight: 400;
    line-height: 170%; /* 1.275rem */

    a {
        color: #fefefe;
    }

    ${breakPoint.desktop} {
        background-color: transparent;
        color: #666;
        font-size: 0.875rem;
        padding: 0;

        a {
            color: #0037ff;
        }
    }
`

export const CustomLogo = styled.img`
    height: 2rem;
    align-self: flex-start;
`

export const Illustrator = styled.img`
    opacity: 0.45;
`
